export default "<m-plane\n    color=\"red\"\n    width=\"5\"\n    height=\"3\"\n    y=\"4\"\n></m-plane>\n";